import {
  Button,
  Flex,
  Image,
  Input,
  Stack,
  Switch,
  Text,
} from '@chakra-ui/react';
import { useAuth0 } from '@auth0/auth0-react';
import { ContentBox } from '../../components/ContentBox';
import { SubSectionHeading } from '../../shared/Typography';
import { StackWithDivider } from '../components/StackWithDivider';
import { usePassword } from '../../auth/use-password';

export const BrandSettingsPage = () => {
  const { isLoading, user } = useAuth0();

  const { sendChangePasswordEmail } = usePassword();

  return (
    <ContentBox>
      <StackWithDivider>
        <SubSectionHeading px="6" py="4">
          Application Name and Logo
        </SubSectionHeading>
        <Stack dir="column" style={{ fontWeight: '500', padding: '25px' }}>
          <Flex
            dir="row"
            alignItems="center"
            justifyContent="space-between"
            width={'100%'}
          >
            <Text>Application Name</Text>
            <Switch />
          </Flex>
          <Flex
            dir="row"
            style={{
              width: '100%',
            }}
          >
            <Stack
              dir="column"
              style={{
                width: '100%',
              }}
            >
              <Text
                style={{
                  fontSize: '14px',
                  color: '#667085',
                  fontWeight: '400',
                }}
              >
                Your application&apos;s name is being shown in Finch Connect as
                Acme Co. <br />
                You can change this name or turn it off.
              </Text>
            </Stack>
            <Stack
              dir="column"
              style={{
                width: '100%',
              }}
            >
              <Stack dir="column">
                <Text>Current Application Name</Text>
                <Input />
              </Stack>
              <Stack dir="column">
                <Text>Display Name</Text>
                <Input />
              </Stack>
            </Stack>
          </Flex>
        </Stack>
      </StackWithDivider>
      <StackWithDivider>
        <SubSectionHeading px="6" py="4">
          <></>
        </SubSectionHeading>
        <Stack
          dir="column"
          style={{ fontWeight: '500', padding: '25px', width: '100%' }}
        >
          <Flex dir="row" width={'100%'}>
            <Text>Application Logo</Text>
          </Flex>
          <Flex
            dir="row"
            alignItems={'center'}
            justifyContent={'space-between'}
            width={'100%'}
            gap={'20'}
          >
            <Stack dir="column" width={'100%'}>
              <Text
                style={{
                  fontSize: '14px',
                  color: '#667085',
                  fontWeight: '400',
                }}
              >
                Update the logo that shows next to the Finch logo in Finch
                Connect. <br /> Accepted file types are JPG, GIF, or PNG.
                Recommended size is 256 x 256 pixels.
              </Text>
            </Stack>
            <Flex dir="row" alignItems={'center'} gap={'10'} width={'100%'}>
              <Image
                src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png"
                width={'100px'}
                height={'100px'}
                borderRadius={'100%'}
                border={'1px solid #D0D5DD'}
              />
              <Button>Change</Button>
            </Flex>
          </Flex>
        </Stack>
      </StackWithDivider>
    </ContentBox>
  );
};
